export const TypeWriter = (el) => {

    const textArray = el.innerHTML.split('');
    el.innerHTML = '';
    textArray.forEach((letter, i) =>
        setTimeout(() => (el.innerHTML += letter), 20 * i)
    );
    el.parentElement.classList.add('completed');
}